var map = {
	"./Burger/burger1.png": 8749,
	"./Burger/burger2.png": 1954,
	"./Burger/burger3.png": 9965,
	"./Burger/burger4.png": 3455,
	"./Categorie/burger.png": 2184,
	"./Categorie/drink.png": 1537,
	"./Categorie/hotdog.png": 6034,
	"./Categorie/loukoum.jpg": 9085,
	"./Categorie/pizza.png": 7351,
	"./Categorie/snack.png": 1328,
	"./Categorie/taco.png": 1398,
	"./Drinks/drink2.png": 4435,
	"./Drinks/drink3.png": 122,
	"./Drinks/drink6.png": 6957,
	"./Hotdog/hotdog1.png": 8545,
	"./Pizza/pizza1.png": 5277,
	"./Pizza/pizza2.png": 9265,
	"./Pizza/pizza3.png": 3967,
	"./Pizza/pizza4.png": 8275,
	"./VisaLogo.png": 1133,
	"./background.png": 8462,
	"./banner.png": 7679,
	"./chip.png": 3733,
	"./delivery.png": 3803,
	"./drive-download-20220518T204039Z-001.zip": 4590,
	"./emptyCart.png": 4199,
	"./logo.png": 1053,
	"./loukoums/loukoum 1.jpg": 1589,
	"./loukoums/loukoum 10.jpg": 6489,
	"./loukoums/loukoum 11.jpg": 9185,
	"./loukoums/loukoum 12.jpg": 4545,
	"./loukoums/loukoum 13.jpg": 3269,
	"./loukoums/loukoum 14.jpg": 4283,
	"./loukoums/loukoum 15.jpg": 5964,
	"./loukoums/loukoum 16.jpg": 7088,
	"./loukoums/loukoum 17.jpg": 5056,
	"./loukoums/loukoum 18.jpg": 4820,
	"./loukoums/loukoum 19.jpg": 6482,
	"./loukoums/loukoum 2.jpg": 8880,
	"./loukoums/loukoum 20.jpg": 283,
	"./loukoums/loukoum 3.jpg": 4228,
	"./loukoums/loukoum 4.jpg": 5053,
	"./loukoums/loukoum 5.jpg": 8020,
	"./loukoums/loukoum 6.jpg": 5266,
	"./loukoums/loukoum 7.jpg": 4801,
	"./loukoums/loukoum 8.jpg": 3756,
	"./loukoums/loukoum 9.jpg": 5125,
	"./photo.jpg": 8157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;